import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { bindPrototypeMethodsToSelf } from '@wix/panorama-common/utils';
import { PanoramaErrorMonitorImpl } from './panorama-error-monitor';
import { PanoramaLoggerImpl } from './panorama-logger';
import { PanoramaTransactionImpl } from './panorama-transaction';
export class PanoramaClientForComponentImpl {
  constructor(_ref) {
    let {
      baseClient
    } = _ref;
    _defineProperty(this, "baseClient", void 0);
    this.baseClient = baseClient;
    bindPrototypeMethodsToSelf(this);
  }
  transaction(name) {
    return new PanoramaTransactionImpl(name, this.baseClient);
  }
  errorMonitor(options) {
    return new PanoramaErrorMonitorImpl(this.baseClient, options);
  }
  logger() {
    return new PanoramaLoggerImpl(this.baseClient);
  }
}
//# sourceMappingURL=panorama-client-component.js.map